import { RetrieveDocumentGenerationJob } from '../../../api';

/** Job still running; not a terminal COMPLETED/FAILED row. */
export const isActiveJobStatus = (status: RetrieveDocumentGenerationJob.status | undefined): boolean =>
  status === RetrieveDocumentGenerationJob.status.PENDING ||
  status === RetrieveDocumentGenerationJob.status.IN_PROGRESS;

export const TERMINAL_STATUSES = new Set([
  RetrieveDocumentGenerationJob.status.COMPLETED,
  RetrieveDocumentGenerationJob.status.FAILED,
]);

export const isTerminalJobStatus = (status: RetrieveDocumentGenerationJob.status | undefined): boolean =>
  status != null && TERMINAL_STATUSES.has(status);
